import _isEmpty from 'lodash/isEmpty';
import _map from 'lodash/map';
import _isNull from 'lodash/isNull';
import _orderBy from 'lodash/orderBy';
import _isUndefined from 'lodash/isUndefined';
import _get from "lodash/get";
import { Platform } from 'react-native';
import { Actions } from '../../../navigation';
import { isPremiumUser } from '@mmt/legacy-commons/Native/UserSession/UserSessionModule';
import fecha from 'fecha';
import {
  getBusRailsPremiumConfig,
  getRailsLandingNewPdtLoggingOnOff,
  showScheduleTatkal,
} from 'apps/rails/src/RailsAbConfig';
import { showShortToast } from '@mmt/legacy-commons/Common/Components/Toast';
import {
  _isUserProfileServieAvailable,
  INPUT_CITY_SELECTED,
  SORTED_SECTION_LIST_WHEN_ORDER_API_FAILS,
  IRCTC_ACCOUNT_REGISTER_COUNT,
  setDataToAsyncStorage,
  getDataFromAsynStorage,
  RAILS_IS_PRE_FC_SELECTED,
  CREATE_ACCOUNT_CLICK,
  IRCTC_CREATE_ACCOUNT_EVENT,
  IRCTC_CAPTCHA_FAILED_EVENT,
  IRCTC_ENTER_VALID_DETAILS_RED_FLAG,
  IRCTC_ENTER_VALID_DETAILS_EVENT,
  IRCTC_SOMETHING_WENT_WRONG_EVENT,
  RAILS_SEO_REDIRECTION_PAGES,
  SEO_REDIRECTIONS_API_TIMEOUT,
  SCHEDULE_TATKAL_EVENTS,
} from '../../../Utils/RailsConstant';
import {
  addToRecentSearches,
  areOriginDestinationDetailsPresent,
  getRecentSearches,
  getStationDetails
} from '../../../Utils/CityRepository';
import {
  createFunnelVars,
  removeEventFromEvar47or97Variable,
  trackLandingEvent,
  updateEvar47or97Variable,
  updateEvar71Variable,
} from '../../../railsAnalytics';
import { now, today } from '@mmt/legacy-commons/Helpers/dateHelpers';
import getFormObject, { fieldsWithOfficeAddress, fieldsWithoutOfficeAddress } from '../../CreateNewAccount/IrctcFormObject';
import { getOffersList } from '@mmt/legacy-commons/Native/OffersModule';
import { initUserFlowDetails } from '../../User/UserVerification/UserVerificationActions';
import { tuneListingTracker } from '../../../Utils/railsTuneTracker';
import { initUserDetails } from '../../TravelerDetails/TravelerDetailsActions';
import railsConfig, { SEO_APP_REDIRECTION_URL } from '../../../RailsConfig';
import fetch2, { Timeout } from '../../../fetch2';
import RailsPdtLandingHelper from '../../../PdtAnalytics/PdtHelper/RailsPdtLandingHelper';
import { getDateFromURLFormat, getQueryParamsFromUrl } from '@mmt/legacy-commons/Helpers/misc';
import {
  getCommonPdtData, trackPdtAfterInitRailsLanding
} from "../../../PdtAnalytics/PdtHelper/RailsPdtUtils";
import { updateRecentSearchHistory } from '@mmt/legacy-commons/Native/GenericModule';
import { trackClickEvent } from '../Analytics/railsLandingPageAnalytics';
import * as ActionTypes from './RailsLandingActionTypes';
import {
  getNonEmptyName, getDeeplinkFromSearchData,
  getCreateNewAccountRequest,
  validate, isDepartureDatePassed
} from './RailsLandinStoreHelper';
import { getRisAb } from '../../RailsBusHomePage/Common/utils';
import {
  getOffersFromSkyWalker,
  getOffersFromSkyWalkerForPremiumUsers,
} from '@mmt/legacy-commons/Native/SkywalkerOffers';

import {getRailsLanguageByKey, _label} from "../../../vernacular/AppLanguage";
import { isMweb, isApp, bookMode } from '../../../Utils/device';
import { getDefaultPostHeaders } from '../../NewListing/RailsListingActions';
import { trackClickEventProp61 } from '../../RailsBusHomePage/Analytics';
import { fetchAppVersion } from '@mmt/core/helpers/appVersionHelper';
import { backIcon } from '@mmt/legacy-commons/Helpers/displayHelper';
import { logLandingEvent, logLandingEventToAll } from '../../../PdtAnalytics/PdtAnalyticsV2/PdtRailsLanding/index';
import { ACTIONS_RAILS_UPCOMING_PNR } from '../../RIS/PnrStatus/RailInfoAction';
import { ACTIONS_RAILS_SCHEDULE_TATAKAL_ALL_FORMS } from './RailsLandingActionTypes';
import {
  deleteScheduleTatkalForm,
  getAllScheduleTatkalForms,
} from '../../ScheduleTatkalTravelerPage/api/ScheduleTatkalApi';
import { isUserLoggedIn } from '@mmt/legacy-commons/Native/UserSession/UserSessionModule';
export const initRailsLanding = dataObject => async (dispatch, getState) => {
  const { railsLanding } = getState();
  dispatch(getIRCTCOffers(dataObject));
  dispatch(initUserFlowDetails());
  dispatch(initUserDetails());
  dispatch(initAppVersion());

  const recentSearch = await getRecentSearches();
  if (_isEmpty(recentSearch)) {
    logLandingEventToAll(
      'LANDING_LOAD',
      {
        originStation: {},
        destinationStation: {},
        departureDate: railsLanding?.departureDate,
        pax: { adult: 1, child: { count: 0, ages: [] }, infant: 0 },
      },
      railsLanding?.isFreeCancellationEnabled,
    );
    return;
  }
  let originStation;
  let destinationStation;
  const [{ from, to, departureDate }] = recentSearch;
  if (!_isEmpty(dataObject) && dataObject.bookReturnTrip) {
    originStation = to;
    destinationStation = from;
  } else {
    originStation = from;
    destinationStation = to;
  }
  dispatch({
    type: ActionTypes.ACTION_ON_ADD_RECENT_SEARCHES,
    data: recentSearch
  });
  if (isMweb() && areOriginDestinationDetailsPresent(railsLanding)) {
    return;
  }
  dispatch({
    type: ActionTypes.ACTION_ON_ORIGIN_SELECTED,
    data: originStation
  });
  dispatch({
    type: ActionTypes.ACTION_ON_DESTINATION_SELECTED,
    data: destinationStation
  });
  let date;
  if (isDepartureDatePassed(departureDate)) {
    date = now();
  } else {
    date = fecha.parse(departureDate, 'DD-MM-YYYY');
  }
  dispatch(setDepartureDate(date));
  let locusDetail = {};
  try {
    locusDetail = await getLocusIdFromStationDetails({
      from_station_code: originStation?.code,
      to_station_code: destinationStation?.code,
    }) || {};
  } catch (_err) {
    console.error('initRailsLanding: failed to fetch locus data', _err);
  }
  dispatch(setLocusData(locusDetail));
  trackPdtAfterInitRailsLanding(railsLanding);
  const logNewMeasurementPlatformPdt = await getRailsLandingNewPdtLoggingOnOff();
  if (logNewMeasurementPlatformPdt) {
    const enrichedOrigin = {
      ...(originStation || {}),
      locusCode: originStation?.locusCode || locusDetail?.fromLocusCode || '',
      locusType: originStation?.locusType || locusDetail?.sourceLocusType || '',
      locusV2Id: originStation?.locusV2Id || locusDetail?.sourceLocusV2Id || '',
      locusV2Type: originStation?.locusV2Type || locusDetail?.sourceLocusV2Type || '',
    };
    const enrichedDestination = {
      ...(destinationStation || {}),
      locusCode: destinationStation?.locusCode || locusDetail?.toLocusCode || '',
      locusType: destinationStation?.locusType || locusDetail?.destinationLocusType || '',
      locusV2Id: destinationStation?.locusV2Id || locusDetail?.destinationLocusV2Id || '',
      locusV2Type: destinationStation?.locusV2Type || locusDetail?.destinationLocusV2Type || '',
    };
    logLandingEventToAll(
      'LANDING_LOAD',
      {
        originStation: enrichedOrigin,
        destinationStation: enrichedDestination,
        departureDate: date || null,
        pax: { adult: 1, child: { count: 0, ages: [] }, infant: 0 },
      },
      railsLanding.isFreeCancellationEnabled,
    );
  }
};

export const updateLandingDetailsFromURL = (data) => async (dispatch) => {
  const { origin, destination, departureDate } = data;
  dispatch({
    type: ActionTypes.ACTION_UPDATE_LANDING_DETAILS,
    data: {
      origin,
      destination,
      departureDate,
      shouldDateBeUpdatedFromURL: false
    }
  })
}

export const setLocusData = (locusResponseData) => (dispatch) => {
  if (locusResponseData) {
    const { fromLocusCode = null, toLocusCode = null, fromLobCode = null, toLobCode = null, fromStationName = null,
      toStationName = null, sourceLocusType = null, destinationLocusType = null,
      sourceLocusV2Id = null, sourceLocusV2Type = null, destinationLocusV2Id = null, destinationLocusV2Type = null,
    } = locusResponseData;
    dispatch({
      type: ActionTypes.ACTION_SET_LOCUS_DETAILS,
      data: {
        LocusDetails: {
          fromLocusCode,
          toLocusCode,
          fromLobCode,
          toLobCode,
          fromStationName,
          toStationName,
          sourceLocusType,
          destinationLocusType,
          sourceLocusV2Id,
          sourceLocusV2Type,
          destinationLocusV2Id,
          destinationLocusV2Type,
        }
      }
    });
  }
}
export const getStationDetailsFromLocus = (data) => {
  return new Promise(async (resolve, reject) => {
    const { from_locus_id, to_locus_id } = data;
    const searchUrl = `${railsConfig.detailFromLocusUrl}?from=${from_locus_id}&to=${to_locus_id}`;
    fetch2(searchUrl)
      .then((res) => res.json())
      .then((responseJson) => {
        if (responseJson.error || !responseJson.success) {
          reject(responseJson.error)
        }
        resolve(responseJson.data)
      })
      .catch((err) => {
        console.log('error');
        reject(err)
      })
  })
}

export const getLocusIdFromStationDetails = (data) => {
  return new Promise(async (resolve, reject) => {
    const { from_station_code, to_station_code } = data;
    const searchUrl = `${railsConfig.locusFromStation}?from=${from_station_code}&to=${to_station_code}`;
    fetch2(searchUrl)
      .then((res) => res.json())
      .then((responseJson) => {
        if (responseJson.error) {
          reject(responseJson.error)
        }
        resolve(responseJson.data)
      })
      .catch((err) => {
        console.log('error');
        reject(err)
      })
  })
}

export const actionResetRailLandingOnLangChange = (dispatch) => {
  const resetObject = {
    originStation: null,
    destinationStation: null,
  }

  dispatch({
    type: ActionTypes.ACTION_RESET_RAIL_LANDING,
    data: resetObject
  });
};

export const getRailOffers = (isPremiumUser) => {
  if (isPremiumUser) {
    return (dispatch) => {
      getOffersFromSkyWalkerForPremiumUsers('RAILS', undefined, getRailsLanguageByKey('cookieCode')) // Todo Vernac remove cookie code
        .then((offersList) => {
          dispatch({
            type: ActionTypes.ACTION_SET_RAILS_OFFERS,
            data: offersList,
          });
          return null; // Explicitly return a value
        })
        .catch((error) => {
          // Handle any errors that occur during the promise execution
          console.error('Error fetching offers:', error);
          throw error; // Rethrow or handle the error as needed
        });
    };
  }
  return (dispatch) => {
    return getOffersFromSkyWalker('RAILS', undefined, getRailsLanguageByKey('cookieCode')) // Todo Vernac remove cookie code
      .then((offersList) => {
        dispatch({
          type: ActionTypes.ACTION_SET_RAILS_OFFERS,
          data: offersList,
        });
        return null; // Explicitly return a value
      })
      .catch((error) => {
        // Handle any errors that occur during the promise execution
        console.error('Error fetching offers:', error);
        throw error; // Rethrow or handle the error as needed
      });
  };
};

export const getIRCTCOffers = (dataObject) => async (dispatch) => {
  let queryParams;
  if (isMweb()) {
    queryParams = getQueryParamsFromUrl(window.location.href);
  }
  else {
    queryParams = getQueryParamsFromUrl(dataObject.landingURL);
  }
  if ((queryParams.category && queryParams.category.toLowerCase() === 'irctc') ||
    (queryParams.cmp && queryParams.cmp.toLowerCase() === 'irctc_app_pp') ||
    (dataObject.cmp && dataObject.cmp.toLowerCase() === 'irctc_app_pp')
  ) {
    dispatch({
      type: ActionTypes.ACTION_UPDATE_BOOKING_SOURCE,
      data: { cmp: queryParams.cmp || dataObject.cmp }
    });
    let lob = 'others';
    let funnel = 'payment'
    const promoAdminData = {
      url: `https://hcs-promo.makemytrip.com/makemytrip/promov3/pwa/pwa/query/?funnel=${funnel}&lob=${lob}`,
      authorizationKey: 'cHdhOjEyMzQ1Ng'
    };
    let res = await fetch2(promoAdminData.url, {
      headers: {
        authorization: promoAdminData.authorizationKey,
      },
    });
    result = await res.json()
    let otherOffersList = [];
    let keys = Object.keys(result.promoMessagesMap);
    let newObj = keys.map(x => result.promoMessagesMap[x])
    try {
      otherOffersList = _map(newObj, (obj) => {
        const newOfferObject = {};
        const originalOfferObj = obj;
        let promoTitle = originalOfferObj.pTl;
        if (!_isEmpty(originalOfferObj.dStxt) && !_isEmpty(originalOfferObj.offerTxt)
          && !_isEmpty(originalOfferObj.dEtxt)) {
          promoTitle = `${originalOfferObj.dStxt} ${originalOfferObj.offerTxt} ${originalOfferObj.dEtxt}`;
        }
        newOfferObject.newHeroOfferCardUrl = originalOfferObj.newHeroOfferCardUrl;
        newOfferObject.promoTitle = promoTitle;
        newOfferObject.promoMessage = originalOfferObj.pTl;
        newOfferObject.promoCode = originalOfferObj.cc;
        newOfferObject.dis = originalOfferObj.dis;
        newOfferObject.url = originalOfferObj.url;
        newOfferObject.lob = 'OTHERS';
        newOfferObject.categories = originalOfferObj.categories;
        return newOfferObject;
      });
      otherOffersList = _orderBy(otherOffersList, ['dis'], ['desc']);
    } catch (e) {
      otherOffersList = [];
    }
    let irctcOffers = otherOffersList.filter(offer => offer.categories.toLowerCase().includes('irctc'))
    dispatch({
      type: ActionTypes.ACTION_SET_OTHER_OFFERS,
      data: irctcOffers
    });
  }
}



export const onOriginClicked = (dispatch, getState) => {
  const { railsLanding: { originStation, destinationStation } } = getState();
  trackClickEvent('mob_rail_landing_source_clicked');
  Actions.railsCityPicker({
    selectedCity: originStation,
    pairedCity: destinationStation,
    inputCitySelected: INPUT_CITY_SELECTED.source,
    actionType: ActionTypes.ACTION_ON_ORIGIN_SELECTED
  });
};

export const openTrainPicker = () => {
  Actions.railsTrainNumberPicker({
    actionType: ActionTypes.ACTION_OPEN_TRAIN_PICKER
  });
};

export const onDestinationClicked = (dispatch, getState) => {
  const { railsLanding: { originStation, destinationStation } } = getState();
  trackClickEvent('mob_rail_landing_destination_clicked');
  Actions.railsCityPicker({
    selectedCity: destinationStation,
    pairedCity: originStation,
    inputCitySelected: INPUT_CITY_SELECTED.destination,
    actionType: ActionTypes.ACTION_ON_DESTINATION_SELECTED
  });
};

export const searchTrains = async (dispatch, getState) => {
  const {
    railsLanding: {
      originStation, destinationStation, departureDate
    }
  } = getState();
  Actions.railsListing({
    originStation,
    destinationStation,
    departureDate,
    fromPage: 'landing',
    openWidget: false
  });

  const date = fecha.format(departureDate, 'DD-MM-YYYY');
  const recentSearch = await addToRecentSearches({
    from: originStation,
    to: destinationStation,
    departureDate: date,
    language: getRailsLanguageByKey("cookieCode"),
  });
  dispatch({
    type: ActionTypes.ACTION_ON_ADD_RECENT_SEARCHES,
    data: recentSearch
  });

  if (isApp()) {
    let originStationCopy = null;
    let destinationStationCopy = null;
    if (originStation.language !== 'en') {
      originStationCopy = await getStationDetails(originStation, 'en');
    } else {
      originStationCopy = originStation;
    }
    if (destinationStation.language !== 'en') {
      destinationStationCopy = await getStationDetails(destinationStation, 'en');
    } else {
      destinationStationCopy = destinationStation;
    }

    const temp = {
      from: getNonEmptyName(originStationCopy),
      to: getNonEmptyName(destinationStationCopy),
      startDate: departureDate.getTime(),
      deeplink: getDeeplinkFromSearchData({
        originStation: originStationCopy,
        destinationStation: destinationStationCopy,
        departureDate
      }),
      language: getRailsLanguageByKey('cookieCode'),
    };

    updateRecentSearchHistory('train', temp);
  }
};

export const onSwapClicked = () => ({
  type: ActionTypes.ACTION_SWAP_SEARCH,
  data: null
});

export const onDateClick = (dispatch, getState) => {
  trackLandingEvent('mob_rail_landing_calendar_click');
  trackClickEvent('mob_rail_landing_date_clicked');
  const { railsLanding: { departureDate } } = getState();
  Actions.railsCalendar({ selectedDate: departureDate });
};

export const setDepartureDate = date => (dispatch) => {
  dispatch({
    type: ActionTypes.ACTION_DATE_SELECTED,
    data: date
  });
};

export const setSelectedClass = selectedClass => (dispatch) => {
  dispatch({
    type: ActionTypes.ACTION_UPDATE_SELECTED_CLASS,
    data: { selectedClass }
  });
};

export const setFreeCancellationOption = (isFCPreSelected) => (dispatch, getState) => {
  const { railsLanding: { isFreeCancellationEnabled=false } = {} } = getState();
  let isFCSelected = !isFreeCancellationEnabled;
  if (isFCPreSelected !== undefined) {
    isFCSelected = isFCPreSelected;
  }
  dispatch({
    type: ActionTypes.ACTION_UPDATE_FREE_CANCELLATION_OPTION,
    data: { isFreeCancellationEnabled: isFCSelected }
  });
};

export const setFreeCancellationUsingStorage = () => async (dispatch) => {
  const isFCSelected = await getDataFromAsynStorage(RAILS_IS_PRE_FC_SELECTED);
  dispatch({
    type: ActionTypes.ACTION_UPDATE_FREE_CANCELLATION_OPTION,
    data: { isFreeCancellationEnabled: isFCSelected }
  });
}

export const selectACCoach = isAcSelected => (dispatch) => {
  if (!isAcSelected) {
    trackLandingEvent('mob_rail_landing_AC_selection');
  }
  dispatch({
    type: ActionTypes.ACTION_AC_BUTTON_TOGGLE,
    data: !isAcSelected
  });
};

export const updateAppState = newAppState => ({
  type: ActionTypes.ACTION_APP_STATE_CHANGE,
  data: newAppState
});

export const trackSearchEvent = (originStation, destinationStation, departureDate) => {
  trackLandingEvent('mob_rail_landing_search');
  const searchEvent = {
    src: originStation,
    dest: destinationStation,
    deptDate: departureDate
  };
  createFunnelVars(searchEvent);
  tuneListingTracker(searchEvent);
};

export const updateLandingPageStateChange = newAppState => (dispatch, getState) => {
  const { railsLanding: { appState, departureDate } } = getState();
  if ((appState === 'inactive' || appState === 'background') && newAppState === 'active' && !_isNull(departureDate)) {
    const selectedDate = departureDate < today() ? today() : departureDate;
    dispatch(setDepartureDate(selectedDate));
  }
  dispatch(updateAppState(newAppState));
};

// export const initRailsFunnelVariant = () => (dispatch) => {
//   let railsFunnelVariant = VARIANT_NEW_LISTING_TRAVELLER_USERFLOW;
//   dispatch({
//     type: ACTION_UPDATE_RAILS_FUNNEL_VARIANT,
//     data: {
//       railsFunnelVariant
//     }
//   });
// };

export const onApplyRecentSearch = searchData => (dispatch) => {
  const { from, to, departureDate } = searchData;
  const date = fecha.parse(departureDate, 'DD-MM-YYYY');
  dispatch({
    type: ActionTypes.ACTION_ON_ORIGIN_SELECTED,
    data: from
  });
  dispatch({
    type: ActionTypes.ACTION_ON_DESTINATION_SELECTED,
    data: to
  });
  dispatch({
    type: ActionTypes.ACTION_DATE_SELECTED,
    data: date
  });
};

export const toggleOfficeCheckBox = state => ({
  type: ActionTypes.ACTION_NEW_ACCOUNT_OFFICE_BUTTON_TOGGLE,
  data: !state
});

const checkValidationOfDataForUserAccount = (dispatch, userAccount) => {
  const { officeCheckBoxEnabled } = userAccount;
  let allItemValidation = true;
  let arrayList = null;
  if (!officeCheckBoxEnabled) {
    arrayList = fieldsWithOfficeAddress();
  } else {
    arrayList = fieldsWithoutOfficeAddress();
  }
  const newUserAccountDataList = arrayList.map((item) => {
    const currentObject = getFormObject()[item];
    if (_isEmpty(userAccount[item]) || _isEmpty(userAccount[item].text)) {
      allItemValidation = false;
      return ({
        [item]: {
          ...userAccount[item],
          error: true,
          errorMessage: currentObject.errorMessage.emptyErrorMessage
        }
      });
    } else {
      const { text } = userAccount[item];
      if (!_isEmpty(currentObject.validationList)) {
        const allValid = currentObject.validationList.reduce((acc, object) =>
          (acc && object.validationFunction(text)));
        if (!allValid) {
          allItemValidation = false;
          return {
            [item]:
            {
              ...userAccount[item],
              error: true,
              errorMessage: currentObject.errorMessage.allNotValidErrorMessage
            }
          };
        }
      }
      return {
        [item]: { ...userAccount[item] }
      };
    }
  });
  const newUserAccountObject = newUserAccountDataList.reduce((acc, item) => ({ ...acc, ...item }));

  if (allItemValidation === false) {
    dispatch({
      type: ActionTypes.ACTION_USER_ACCOUNT_VALIDATION_FAIL,
      data: newUserAccountObject
    });
  }
  return (allItemValidation);
};



export const setPinCodeData = (currentObject, pinCodeData) => async (dispatch) => {
  const { pinCode: { text, error = false, errorMessage = '' }, selectCity, selectPostOffice, selectState, isOffice } = pinCodeData;
  const formObject = getFormObject();
  dispatch({
    type: ActionTypes.ACTION_SET_PIN_CODE_DATA,
    data: { [currentObject.id]: { text, error, errorMessage } }
  });
  dispatch(addMultiUserData([
    {
      currentObject: isOffice ? formObject.selectOfficeCity : formObject.selectCity,
      selectedObject: selectCity
    },
    {
      currentObject: isOffice ? formObject.selectOfficePostOffice : formObject.selectPostOffice,
      selectedObject: selectPostOffice
    },
    {
      currentObject: isOffice ? formObject.selectOfficeState : formObject.selectState,
      selectedObject: selectState
    },
  ]));
};

export const fillCreateAccountData = async (dispatch, getState) => {
  try {
    setDataToAsyncStorage(IRCTC_ACCOUNT_REGISTER_COUNT,0);
    setDataToAsyncStorage(CREATE_ACCOUNT_CLICK,null);

    const res = await fetch2(railsConfig.securityOccupationList);

    if (!_isEmpty(res.status) && res.status !== 200) {
      throw new Error('wrong Status code');
    }

    const response = await res.json();

    if (!_isEmpty(response.errorMessage)) {
      throw new Error('wrong Status code');
    }
    const { securityQuestionList, occupationList } = response;
    const dispatchObject = { securityQuestionList, occupationList };
    dispatch({
      type: ActionTypes.ACTION_FILL_USER_DATA,
      data: dispatchObject
    });
  } catch (e) {
    console.log('error in fillCreateAccountData', e);
    showShortToast(_label("something_went_wrong_try_again_later") + " Error Code: " +  e?.errorCode );
  }
  const  userDetails  = await getDataFromAsynStorage('rails_user_details');
  try {
    const formObject = getFormObject();
    dispatch(addMultiUserData([
      {
        currentObject: formObject.selectGender,
        selectedObject: formObject.selectGender.dropDownList.find(item => item.text.toLowerCase() === userDetails.gender.toLowerCase())
      },
      {
        currentObject: formObject.selectLanguage,
        selectedObject: formObject.selectLanguage.dropDownList[0]
      }]));
    dispatch(addMultiTextData([{ currentObject: formObject.enterFirstName, selectedValue: userDetails.firstName },
    { currentObject: formObject.enterLastName, selectedValue: userDetails.lastName },
    { currentObject: formObject.enterEmail, selectedValue: userDetails.email },
    { currentObject: formObject.enterMobileNumber, selectedValue: userDetails.mobile.mobileNumber }
    ]));
  } catch (e) {

  }
};

export const captchaAndSessionId = async (dispatch, getState) => {
  try {
    dispatch({
      type: ActionTypes.ACTION_SET_SESSION_ID_AND_CAPTCHA,
      data: { captchaLoading:true }
    });
    const res = await fetch2(railsConfig.getUserSession, {
      headers: {
        "bookMode": bookMode()
      }
    });
    const response =  await res.json();
    const { captchaQuestion = null, status = null } = response?.data || {};
    const { success, error = null } = response;

    if (res.status === 200 && success) {
      dispatch({
        type: ActionTypes.ACTION_SET_SESSION_ID_AND_CAPTCHA,
        data: { captchaQuestion, status,captchaLoading:false ,captchaDowntimeError: error }
      });
    }
    else
    {
      trackClickEventProp61(IRCTC_CREATE_ACCOUNT_EVENT,IRCTC_CAPTCHA_FAILED_EVENT);
      dispatch({
        type: ActionTypes.ACTION_SET_SESSION_ID_AND_CAPTCHA,
        data: { captchaQuestion:null, status:null,captchaLoading:false,captchaDowntimeError: null  }
      });
    }
  }
  catch (e) {
    trackClickEventProp61(IRCTC_CREATE_ACCOUNT_EVENT,IRCTC_CAPTCHA_FAILED_EVENT);
    dispatch({
      type: ActionTypes.ACTION_SET_SESSION_ID_AND_CAPTCHA,
      data: { captchaQuestion:null, status:null,captchaLoading:false,captchaDowntimeError: null  }
    });
    showShortToast(_label("captcha_could_not_load") + " Error Code: " + e?.errorCode );
    console.log('error is ', e);
  }
}

export const onCreateAccountClick = (props) => async (dispatch, getState) => {
  let  accountRegisterApiCount  = await getDataFromAsynStorage(IRCTC_ACCOUNT_REGISTER_COUNT);
  setDataToAsyncStorage(CREATE_ACCOUNT_CLICK,true);
  if(!accountRegisterApiCount)
  {
    accountRegisterApiCount=0;
  }
  try {
    if (!_isUserProfileServieAvailable()) {
      return;
    }
    const { railsLanding: { userAccount } } = getState();
    if (checkValidationOfDataForUserAccount(dispatch, userAccount)) {
      const { userName: { text } } = userAccount;
      const requestBody = getCreateNewAccountRequest(userAccount);

      dispatch({
        type: ActionTypes.ACTION_SET_USER_DATA_LOADER,
        data: { userDataLoader: true }
      });
      const res = await fetch2(railsConfig.createAccount, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(requestBody)
      });

      dispatch({
        type: ActionTypes.ACTION_SET_USER_DATA_LOADER,
        data: {userDataLoader: false}
      });
      setDataToAsyncStorage(IRCTC_ACCOUNT_REGISTER_COUNT, (accountRegisterApiCount + 1) % 10 );
      if (!_isEmpty(res.status) && res.status !== 200) {
        throw new Error('wrong Status code');
      }

      const response = await res.json();
      if (response.regFlag === false && !response?.error) {
        dispatch({
          type: ActionTypes.ACTION_SET_TO_INIT_STATE_USER_DATA,
          data: null
        });
        Actions.railsCreateAccountSuccess({
          type: 'replace',
          userName: text,
          from: props.from,
          probableTo: props.probableTo,
          nextPageProps: props.nextPageProps
        });
      } else if (response.regFlag === true) {
        trackClickEventProp61(IRCTC_CREATE_ACCOUNT_EVENT,IRCTC_ENTER_VALID_DETAILS_RED_FLAG);
        showShortToast(_label(`${response?.error}`));
       }
       else if (response?.error === 'Invalid Captcha.') {
         if (accountRegisterApiCount === 9) {
           props.captchaAndSessionId();
         }
         else {
           const { captchaQuestion,status } = response?.captchaDTO;
           dispatch({
             type: ActionTypes.ACTION_SET_SESSION_ID_AND_CAPTCHA,
             data: { captchaQuestion, status, captchaLoading: false,captchaDowntimeError:null }
           });
         }
         showShortToast(_label("invalid_captcha"));
       } else {
         trackClickEventProp61(IRCTC_CREATE_ACCOUNT_EVENT,IRCTC_SOMETHING_WENT_WRONG_EVENT)
         showShortToast(_label("something_went_wrong") + " Error Code: " + e?.errorCode );
       }
     } else {
       trackClickEventProp61(IRCTC_CREATE_ACCOUNT_EVENT,IRCTC_ENTER_VALID_DETAILS_EVENT)
       showShortToast(_label("please_fill_valid_details"));
     }
   } catch (e) {
     dispatch({
       type: ActionTypes.ACTION_SET_USER_DATA_LOADER,
       data: { userDataLoader: false }
     });
     setDataToAsyncStorage(IRCTC_ACCOUNT_REGISTER_COUNT, (accountRegisterApiCount + 1) % 10 );
     showShortToast(_label("something_went_wrong"+" Error Code: " + e?.errorCode ));
     console.log('error is ', e);
   }
 };

export const addMultiTextData = data => async (dispatch) => {
  const textData = await data.reduce(async (a, { currentObject, selectedValue }) => {
    const { error, errorMessage } = await validate(selectedValue, currentObject);
    return {
      ...await a,
      [currentObject.id]: { text: selectedValue, error, errorMessage }
    };
  }, {});
  dispatch({
    type: ActionTypes.ACTION_ADD_USER_DATA,
    data: textData
  });
};

export const addMultiUserData = data => async (dispatch) => {
  const userData = data.reduce((a, { currentObject, selectedObject }) => ({
    ...a,
    [currentObject.id]: { ...selectedObject, error: false, errorMessage: '' }
  }), {});
  dispatch({
    type: ActionTypes.ACTION_ADD_USER_DATA,
    data: userData
  });
};

export const addTextData = data => async (dispatch) => {
  const { currentObject, selectedValue } = data;
  const { error, errorMessage } = await validate(selectedValue, currentObject);
  const dispatchObject = { [currentObject.id]: { text: selectedValue, error, errorMessage } };
  dispatch({
    type: ActionTypes.ACTION_ADD_USER_DATA,
    data: dispatchObject
  });
};

export const setCaptchaToNull = () => async (dispatch) => {
  dispatch({
    type: ActionTypes.ACTION_SET_CAPTCHA_NULL,
    data: {}
  });
}

export const addUserData = data => (dispatch) => {
  const { currentObject, selectedObject } = data;
  const dispatchObject = { [currentObject.id]: { ...selectedObject, error: false, errorMessage: '' } };
  dispatch({
    type: ActionTypes.ACTION_ADD_USER_DATA,
    data: dispatchObject
  });
};

/**
 *
 * Pdt related actions
 *
 */

export const trackPdtLandingLoad = async (data)  => {
  const { searchContextData } = data;
  const commonPdt = await getCommonPdtData();
  const pdtData = {
    ...commonPdt,
    searchContextData
  };
  RailsPdtLandingHelper.trackPageLoad(pdtData);
};

const defaultSections = SORTED_SECTION_LIST_WHEN_ORDER_API_FAILS;

const updateSectionOrders = async (sections, dispatch) => {
  dispatch({
    type: ActionTypes.ACTION_FETCH_SECTION_ORDERS_SUCCESS,
    payload: {
      sectionOrder: sections,
    },
  });
};

const areSectionsAvailableOrLoading = (getState) => {
  const { railsLanding: { sectionOrder, sectionOrderLoading }} = getState();
  return sectionOrder.length > 0 || sectionOrderLoading;
}

export const fetchSectionOrder = () => {
  return async (dispatch, getState) => {
    try {
      if (areSectionsAvailableOrLoading(getState)) {
        return;
      }
      dispatch({
        type: ActionTypes.ACTION_FETCH_SECTION_ORDERS_INIT,
      });

      const url = railsConfig.railsLandingCardOrderUrl;
      const res = await fetch2(url, {
        method: 'GET',
        headers: getDefaultPostHeaders(),
      });
      const data = await res.json();
      const payload = _get(data, 'sortedSectionList', defaultSections);
      updateSectionOrders(payload, dispatch);
      const railsBusPremiumPokus = await getBusRailsPremiumConfig();
      const premiumUser = await isPremiumUser();
      if (premiumUser && railsBusPremiumPokus) {
        dispatch(getRailOffers(true));
        return;
      }
      dispatch(getRailOffers());
    } catch (err) {
      console.error("ERROR", err.message);
      updateSectionOrders(defaultSections, dispatch);
    }
  }
}

export const upComingPnrs = () => async (dispatch) => {

  try {
    const url = railsConfig.upComingPnrsUrl;
    const response = await fetch2(url, {
      method: 'GET',
      headers: getDefaultPostHeaders(),
    });
    const res = await response.json();

      dispatch({
        type: ACTIONS_RAILS_UPCOMING_PNR,
        data: res,
      });
  } catch (e) {
    dispatch({
      type: ACTIONS_RAILS_UPCOMING_PNR,
      data: {
        suggestedBookings: [],
      },
    });
    console.log('error is ', e);
  }
};

const defaultRisOptions = ['TGS','CPS', 'LTS', 'FIT', 'STS', 'CSA', 'LSS', 'CPP','VCH'];
export const fetchRisOptions = () => {
  return (dispatch) => {
    if (Platform.OS !== 'web') {
      getRisAb().then(response => {
        dispatch({
          type: ActionTypes.ACTION_FETCH_RIS_OPTION_SUCCESS_APP,
          payload: response,
        })
      })
    } else {
      dispatch({
        type: ActionTypes.ACTION_FETCH_RIS_OPTION_SUCCESS_WEB,
        payload: defaultRisOptions,
      })
    }
  }
}

export const updateLTSDate = dateObj => async (dispatch) => {
  dispatch({
    type: ActionTypes.ACTION_UPDATE_LTS_DATE,
    data: dateObj
  });
};

export const updateLTSBoardingData = boardingData => async (dispatch) => {
  dispatch({
    type: ActionTypes.ACTION_UPDATE_LTS_BOARDING_DATA,
    data: boardingData
  });
};

export const updateStartDateOption = startDateOptionSelected => async (dispatch) => {
  dispatch({
    type: ActionTypes.ACTION_UPDATE_START_DATE_OPTION,
    data: startDateOptionSelected
  });
};
export const initAppVersion =  () => async (dispatch) => {
  const appVersion = await fetchAppVersion();
  dispatch({
    type: ActionTypes.ACTION_SET_APP_VERSION,
    data: appVersion,
  });
};

export const redirectFromSeo =
  (webPageUrl = '') =>
  async (dispatch, getState) => {
    const {
      railsLanding: { redirectedFromSeo },
    } = getState();
    if (webPageUrl && !redirectedFromSeo) {
      dispatch({
        type: ActionTypes.ACTION_REDIRECT_FROM_SEO,
        data: { isLoading: true },
      });
      try {
        const url = SEO_APP_REDIRECTION_URL + (webPageUrl?.split('/railways/')?.[1] ?? '');
        const response = await fetch2(url, {
          signal: Timeout(SEO_REDIRECTIONS_API_TIMEOUT).signal,
        });
        const res = await response.json();
        updateEvar71Variable('Source=SEO');
        switch (res?.pageName) {
          case RAILS_SEO_REDIRECTION_PAGES.LISTING: {
            const queryParams = getQueryParamsFromUrl(res?.redirectURL);
            if (queryParams?.from && queryParams?.to && queryParams?.departure) {
              const params = {
                originStation: {
                  code: queryParams?.from,
                },
                destinationStation: {
                  code: queryParams?.to,
                },
                departureDate: getDateFromURLFormat(queryParams?.departure),
                deep_link_intent_url: res?.redirectURL || webPageUrl,
              };
              Actions.railsListing(params);
            }
            break;
          }
          case RAILS_SEO_REDIRECTION_PAGES.PNR:
            Actions.railsPNRStatusLanding();
            break;
          case RAILS_SEO_REDIRECTION_PAGES.LIVE_STATUS:
            Actions.railLiveTrainStatusLanding();
            break;
          case RAILS_SEO_REDIRECTION_PAGES.LTS_DETAILS:
            if (res?.trainNumber) {
              Actions.railLiveTrainStatusRNLanding({
                requestDetails: {
                  trainDetail: {
                    trainNumber: res?.trainNumber,
                  },
                },
              });
            }
            break;
          case RAILS_SEO_REDIRECTION_PAGES.RAILS_BUS_COMMON_LANDING:
            Actions.railsBusCommonLanding(undefined, 'replace');
            break;
          case RAILS_SEO_REDIRECTION_PAGES.WEBVIEW:
            Actions.openWebView({
              headerText: 'MakeMyTrip',
              url: webPageUrl,
              headerIcon: backIcon,
            });
            break;
        }
      } catch (e) {
        console.error('Error in redirectFromSeo', e);
      }
      dispatch({
        type: ActionTypes.ACTION_REDIRECT_FROM_SEO,
        data: { isLoading: false, redirectedFromSeo: true },
      });
    }
  };

export const initPremiumUserLanding = (props) => async (dispatch) => {
  try {
    if (!_isEmpty(props?.tripDetails?.from) && !_isEmpty(props?.tripDetails?.to)) {
      const { from, to } = props?.tripDetails || {};
      const originStation = await getStationDetails({ code: from });
      const destinationStation = await getStationDetails({ code: to });
      if (!_isEmpty(originStation) && !_isEmpty(destinationStation)) {
        dispatch({
          type: ActionTypes.ACTION_ON_ORIGIN_SELECTED,
          data: originStation,
        });
        dispatch({
          type: ActionTypes.ACTION_ON_DESTINATION_SELECTED,
          data: destinationStation,
        });
      }
      return;
    }

    const recentSearch = await getRecentSearches();
    if (recentSearch?.length === 0) {
      return;
    }
    const [{ from, to, departureDate }] = recentSearch;
    const originStation = from;
    const destinationStation = to;
    dispatch({
      type: ActionTypes.ACTION_ON_ADD_RECENT_SEARCHES,
      data: recentSearch,
    });
    dispatch({
      type: ActionTypes.ACTION_ON_ORIGIN_SELECTED,
      data: originStation,
    });
    dispatch({
      type: ActionTypes.ACTION_ON_DESTINATION_SELECTED,
      data: destinationStation,
    });
    let date;
    if (isDepartureDatePassed(departureDate)) {
      date = now();
    } else {
      date = fecha.parse(departureDate, 'DD-MM-YYYY');
    }
    dispatch(setDepartureDate(date));
    const locusDetail = await getLocusIdFromStationDetails({
      from_station_code: originStation?.code,
      to_station_code: destinationStation?.code,
    });
    dispatch(setLocusData(locusDetail));
  } catch (e) {
    console.error('error in initPremiumUserLanding', e);
  }
};

// Action to schedule Tatkal forms
export const getScheduleTatakalAllForms = () => async (dispatch) => {
  try {
    removeEventFromEvar47or97Variable(SCHEDULE_TATKAL_EVENTS.scheduleTatkalDisabled);
    removeEventFromEvar47or97Variable(SCHEDULE_TATKAL_EVENTS.scheduleTatkalEnabled);
    const isLoggedIn = await isUserLoggedIn();
    if (isLoggedIn && !showScheduleTatkal()) {
      updateEvar47or97Variable(SCHEDULE_TATKAL_EVENTS.scheduleTatkalDisabled);
      return;
    }
    if (!isLoggedIn || !showScheduleTatkal()) {
      return;
    }
    const res = await getAllScheduleTatkalForms();
    dispatch({
      type: ACTIONS_RAILS_SCHEDULE_TATAKAL_ALL_FORMS,
      data: { scheduleTatkalForms: res?.length > 0 ? res : [] },
    });
    updateEvar47or97Variable(SCHEDULE_TATKAL_EVENTS.scheduleTatkalEnabled);
  } catch (error) {
    console.error('Failed to fetch Tatkal forms:', error);
  }
};

export const deleteScheduledTatkalFormClick = (form) => async (dispatch) => {
  try {
    if (!form?.formId) {
      showShortToast(_label('something_went_wrong_try_again_later'));
      return false;
    }
    const res = await deleteScheduleTatkalForm(form?.formId);
    if (res?.error || res?.errorMessage) {
      showShortToast(res?.errorMessage || _label('something_went_wrong_try_again_later'));
      return false;
    } else {
      showShortToast(res?.message || _label('tatkal_form_deleted_successfully'));
      dispatch(getScheduleTatakalAllForms());
      return true;
    }
  } catch (error) {
    console.error('Failed to delete Tatkal form:', error);
    showShortToast(_label('something_went_wrong_try_again_later'));
    return false;
  }
};
